import { doc, getDoc, setDoc, updateDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";

/**
 * @param {string} uid
 * @returns {Promise<Record<string, unknown> | null>}
 */
export async function fetchUserProfile(uid) {
  const snap = await getDoc(doc(db, "users", uid));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

/**
 * Creates users/{uid} per Firestore security rules (Phase 1 bootstrap).
 * @param {string} uid
 */
export async function createUserProfile(uid) {
  const ref = doc(db, "users", uid);
  const now = serverTimestamp();
  await setDoc(ref, {
    uid,
    createdAt: now,
    updatedAt: now,
  });
}

/**
 * @param {string} uid
 * @param {Record<string, unknown>} patch
 */
export async function patchUserProfile(uid, patch) {
  await updateDoc(doc(db, "users", uid), {
    ...patch,
    updatedAt: serverTimestamp(),
  });
}

/**
 * Owner delete of users/{uid} (erase account mode).
 * @param {string} uid
 */
export async function deleteUserProfile(uid) {
  await deleteDoc(doc(db, "users", uid));
}
